export default "__VITE_ASSET__Ccdie1xr__"